import { createApp, h } from 'vue';
import type { App } from 'vue';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { SaveToProjectOptions } from './index';
import { i18n } from '../locales';

export interface OpenDialogService {
    open(options: SaveToProjectOptions): Promise<unknown>
}

@injectable()
export class OpenDialogServiceImpl implements OpenDialogService {
    private _div: HTMLDivElement | null = null;
    private _html: HTMLHtmlElement | null = null;
    private _app: App<Element> | null = null;

    private async _getSaveDialog() {
        const component = await import('../component/SaveDialog.vue').then(m => m.default)
        return component
    }

    private _createContainer() {
        this._html = window.parent.document.querySelector('html')
        this._html?.setAttribute('style', 'overflow:hidden')
        if (this._div) {
            this._div.remove()
        }
        this._div = document.createElement('div');
        this._div.setAttribute('data-theme', 'patsnapRD');
        this._div.setAttribute('class', 'save-to-project-dialog')
        this._div.style.cssText = 'display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:2000;';
        document.body.appendChild(this._div);
        return this._div;
    }

    private _destroyContainer() {
        this._div?.remove();
        this._app?.unmount();
        this._html?.removeAttribute('style');
        return this;
    }

    async open(data: SaveToProjectOptions) {
        const div = this._createContainer();
        const component = await this._getSaveDialog();
        const promise = new Promise((resolve, reject) => {
            const $vm = this;
            this._app = createApp({
                render() {
                    return h(component, {
                        initData: data,
                        onSuccess: (data: boolean) => {
                            resolve(data)
                            $vm._destroyContainer()
                        },
                        onClose: () => {
                            reject(new Error('close'))
                            $vm._destroyContainer()
                        },
                    });
                },
            });
            this._app.use(i18n)
            this._app.mount(div);
        });
        return promise;
    }
}

export const OpenDialogService = Symbol('OpenDialogService');
